import type { TranslationsType } from "../types/TranslationsType"

export const fiTranslations: TranslationsType = {
  header: {
    title: "Asiakastietojenhallintajärjestelmä",
    logout: "Kirjaudu ulos"
  },
  globalNavigation: {
    customers: "Asiakkaat",
    home: "Etusivu"
  },
  customers: {
    pageTitle: "Asiakkaat",
    searchPlaceholder: "Etsi nimen perusteella",
    noCustomersFound: "Asiakkaita ei löytynyt",
    table: {
      name: "Nimi",
      salesforceId: "Salesforce ID",
      id: "ID",
      taxNumber: "Verotunniste",
      rows: "Rivit",
      openConfiguration: "Avaa taulukon asetukset",
      subType: "Alityyppi",
      relationshipType: "Suhdetyyppi",
      customer: "Asiakas",
      billingEntity: "Laskuttaja",
      formerCustomer: "Entinen asiakas",
      customersAffiliate: "Asiakkaan tytäryhtiö",
      sdmEmail: "SDM sähköpostiosoite"
    },
    tableManager: {
      previewTooltipWarning: "Sulje taulukon asetukset vuorovaikuttaaksesi näkymän kanssa",
      cancelBtn: "Peruuta",
      saveBtn: "Tallenna",
      closePreviewBtn: "Sulje esikatselu",
      showPreviewBtn: "Esikatsele {{count}} muutosta",
      newGroup: "Uusi ryhmä",
      newGroupTooltip: "Lisää uusi sarakeryhmä",
      columnManagerSubtitle: "Taulukon asetukset",
      optionsTitle: "Käytettävissä olevat parametrit",
      confirmSaveBtn: "Tallenna",
      confirmSaveCancelBtn: "Peruuta",
      confirmSaveTitle: "Tallennetaanko taulukon asetukset?",
      confirmSaveMessage:
        "Muutokset tallennetaan selaimesi paikalliseen tallennuspaikkaan ja säilyvät istuntojen välillä. Nämä asetukset ovat selainkohtaisia eivätkä vaikuta muihin käyttäjiin."
    },
    loading: {
      text: "Ladataan asiakkaita..."
    }
  },
  home: {
    pageTitle: "Etusivu"
  },
  login: {
    pageTitle: "Asiakastietojenhallintajärjestelmä",
    subtitle: "Et ole kirjautunut sisään. Kirjaudu sisään uudelleen jatkaaksesi.",
    msalOption: "Microsoft Entra ID (suositeltu)",
    signInMsal: "Kirjaudu sisään Microsoft Entra ID:llä",
    signInOidc: "Kirjaudu sisään OIDC Identity Serverillä",
    alreadySignedIn: "Olet jo kirjautunut sisään.",
    goToHome: "Siirry etusivulle",
    msalFailureTitle: "Microsoft Entra ID kirjautuminen epäonnistui",
    msalFailureMessage:
      "Microsoft Entra ID kirjautuminen ei onnistunut. Voit yrittää kirjautua sisään OIDC Identity Serverin kautta."
  },
  customer: {
    tabs: {
      overview: "Yleisnäkymä",
      planresources: "Plan resurssit"
    },
    overview: {
      customerTime: "Asiakkaan aika",
      descriptionTitle: "Tietoja asiakkaasta",
      hierarchyTitle: "Organisaatiorakenne",
      modulesTitle: "Moduulit",
      linksTitle: "Linkit",
      noModules: "Asiakkaalla ei ole moduuleja",
      modulesNoAccess: "Nämä tiedot eivät ole saatavilla sinulle.",
      noRelatedCustomers: "Liittyviä asiakkaita ei löytynyt",
      loadingHierarchy: "Ladataan asiakashierarkiaa...",
      noDescription: "Asiakkaasta ei ole saatavilla kuvausta.",
      generateDescription: "Luo AI-kuvaus",
      descriptionError: "Kuvauksen luominen epäonnistui. Yritä myöhemmin uudelleen."
    }
  },
  visualization: {
    creatingGraph: "Luodaan kaaviota...",
    billingEntity: "Laskutusentiteetti",
    error: {
      neighboringNodesForNode: "Naapurisolmujen lataaminen epäonnistui: {{nodeName}}",
      neighboringNodes: "Naapurisolmujen lataaminen epäonnistui",
      retry: "Yritä uudelleen",
      unknown: "Tapahtui tuntematon virhe"
    },
    nodePropertiesDisplay: {
      sidebarLocked: "Sivupaneeli lukittu",
      sidebarUnlocked: "Sivupaneeli avattu",
      lockSidebar: "Lukitse sivupaneeli",
      unlockSidebar: "Avaa sivupaneeli",
      nodeProperties: "Solmun ominaisuudet",
      editParent: "Muokkaa ylätasoa",
      editParentTitle: "Muokkaa ylätaso asiakkaalle {{nodeName}}",
      parent: "Ylätaso",
      searchParentPlaceholder: "Hae ylätaso...",
      noParentsFound: "Ylätasoja ei löytynyt",
      searchResults: "Hakutulokset",
      currentParent: "{{name}} (nykyinen ylätaso)",
      selectParent: "Valitse {{name}} ylätasoksi"
    },
    toast: {
      parentUpdated: {
        title: "Ylätaso päivitetty onnistuneesti",
        message: "Plan customer {{customerName}} on siirretty asiakkaalle {{parentName}}.",
        viewLink: "Näytä",
        planResources: "Plan resurssien kaavio"
      },
      parentUpdateFailed: {
        title: "{{customerName}} päivittäminen epäonnistui",
        errorPrefix: "Virhe:",
        forbidden: "Sinulla ei ole oikeutta päivittää ylätason suhdetta"
      }
    }
  },
  unauthorized: {
    pageTitle: "Oikeudet puuttuvat",
    description: "Sinulla ei ole vielä vaadittavia oikeuksia tähän sovellukseen. Pyynnön tunniste: {{subId}}.",
    button: "Yritä uudelleen",
    requestButtonLabel: "Pyydä pääsyä",
    requestedButtonLabel: "Pääsyä pyydetty",
    requestSuccessTitle: "Pyyntö lähetetty.",
    requestSuccessDescription: "Tiimi tarkistaa pyyntösi.",
    requestErrorTitle: "Pyynnön lähettäminen epäonnistui.",
    requestErrorDescription:
      "Yritä myöhemmin uudelleen. Jos ongelma jatkuu, ota yhteyttä tech-cmdb-feedback Slack-kanavalla."
  },
  errorBoundary: {
    pageTitle: "Jotain meni pieleen",
    defaultDescription: "Tapahtui virhe",
    button: "Yritä uudelleen"
  },
  vpnError: {
    pageTitle: "Yhteysvirhe",
    description: "Tämä saattaa liittyä VPN-yhteyteen. Kokeile seuraavia vaiheita:",
    step1: "Yhdistä yrityksen VPN:ään",
    step2: "Odota vakaata yhteyttä",
    step3: "Päivitä sivu",
    technicalDetails: "Näytä tekniset tiedot"
  },
  general: {
    close: "Sulje",
    cancel: "Peruuta",
    save: "Tallenna"
  },
  sessionRecovery: {
    title: "Istunto vanhentunut",
    message: "Istuntosi on vanhentunut. Klikkaa Jatka kirjautuaksesi uudelleen ja jatkaaksesi siitä, mihin jäit.",
    resume: "Jatka",
    resuming: "Kirjaudutaan..."
  },
  dynamicForm: {
    loading: "Ladataan lomaketta...",
    loadError: "Lomakkeen lataus epäonnistui",
    menuTitlesLoadError: "Asiakkaan saatavilla olevien lomakkeiden lataus epäonnistui.",
    noViewAccessTitle: "Lomake ei saatavilla",
    noViewAccess: "Tämä lomake ei ole saatavilla tälle asiakkaalle, tai sinulla ei ole oikeuksia nähdä sitä.",
    noDeploymentAccess: "Sinulla ei ole oikeutta luoda tämän asiakkaan konfiguraatioita."
  }
}
